'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ExpandMoreIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ExpandMoreIcon">
      <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.9425 0L4.5 3.435L1.0575 0L0 1.0575L4.5 5.5575L9 1.0575L7.9425 0Z" fill={sx?.color || 'white'} />
      </svg>
    </SvgIcon>
  )
}

ExpandMoreIcon.propTypes = {
  sx: PropTypes.object
}
